import { makeApiProvider } from '@pflegenavi/shared-frontend/platform';
import { createContext } from 'react';
import type {
  IUserProfilePhoenixApi,
  UpdateUserProfileParams,
  UpdateUserProfileResult,
} from './api';
import { UserProfilePhoenixApi } from './api';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const ApiContext = createContext<IUserProfilePhoenixApi | undefined>(undefined);
const {
  useApi: useUserProfilePhoenixApi,
  ApiProvider: UserProfilePhoenixApiProvider,
} = makeApiProvider({
  name: 'UserProfilePhoenix',
  ApiContext,
  newApi: (tenantId, auth, apiUrl) =>
    new UserProfilePhoenixApi(tenantId, auth, apiUrl),
});

export { UserProfilePhoenixApiProvider };
export type { UpdateUserProfileParams, UpdateUserProfileResult };

export const useUpdateUserProfilePhoenix = (): UseMutationResult<
  UpdateUserProfileResult,
  unknown,
  UpdateUserProfileParams
> => {
  const api = useUserProfilePhoenixApi();
  const queryClient = useQueryClient();

  return useMutation<UpdateUserProfileResult, unknown, UpdateUserProfileParams>(
    {
      mutationKey: ['update_user_profile_phoenix'],
      mutationFn: (data) =>
        api.updateUserProfile({
          body: data,
        }),
      onSuccess: async () => {
        // Invalidate any user profile queries if needed
        await queryClient.invalidateQueries({
          queryKey: ['user-profile'],
        });
      },
    }
  );
};
